import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import { Glyphicon } from '@bingads-webui-react/primitive';
import { CommandBarButton } from '@bingads-webui-react/fabric-control';
import { OPERATORS } from './operator';

export class ControlsToolbar extends React.PureComponent {
  static propTypes = {
    className: PropTypes.string,
    metricDropDownClassName: PropTypes.string.isRequired,
    metricCategoryDropDownClassName: PropTypes.string.isRequired,
    i18n: PropTypes.shape({
      getString: PropTypes.func.isRequired,
    }).isRequired,
    metricCategories: PropTypes.arrayOf(PropTypes.shape({
      titleKey: PropTypes.string.isRequired,
      metrics: PropTypes.arrayOf(PropTypes.shape({
        metric: PropTypes.string.isRequired,
        titleKey: PropTypes.string.isRequired,
      })).isRequired,
    })).isRequired,
    onOperatorSelected: PropTypes.func,
    onMetricSelected: PropTypes.func,
    zIndexStart: PropTypes.number,
  };

  static defaultProps = {
    className: 'expression-editor-controls',
    onOperatorSelected: _.noop,
    onMetricSelected: _.noop,
    zIndexStart: 1000,
  };

  state = { metricPickerVisible: false };

  toggleMetricPicker = () => this.setState(({ metricPickerVisible }) => ({
    metricPickerVisible: !metricPickerVisible,
  }));

  closeMetricPicker = () => this.setState({
    metricPickerVisible: false,
  });

  render() {
    const {
      className,
      i18n,
      metricCategories,
      onMetricSelected,
      onOperatorSelected,
      zIndexStart: zIndex,
      metricDropDownClassName,
      metricCategoryDropDownClassName,
    } = this.props;

    const menuItems = _.map(metricCategories, category => ({
      key: category.titleKey,
      text: i18n.getString(category.titleKey),
      className: metricDropDownClassName,
      items: _.map(category.metrics, ({ titleKey, metric }) => {
        const text = i18n.getString(titleKey);
        return {
          key: metric,
          text,
          className: 'custom-column-metric-item',
          onClick: () => onMetricSelected({
            value: metric,
            title: text,
          }),
        };
      }),
    }));

    const operators = _.map(_.values(OPERATORS), operator => (
      <CommandBarButton
        key={operator.value}
        onClick={() => onOperatorSelected(operator.value)}
        className="btn-command"
        ariaLabel={i18n.getString(operator.i18nKey)}
      >
        <Glyphicon glyph={operator.iconName} />
      </CommandBarButton>
    ));

    return (
      <div
        className={className}
        aria-label={i18n.getString('CustomColumnExpressionEditor_ButtonGroupLabel')}
        style={{ zIndex }}
      >
        <CommandBarButton
          iconProps={{
                iconName: 'Add',
               }}
          ariaLabel={i18n.getString('CustomColumnExpressionEditor_MetricPickerLabel')}
          text={i18n.getString('CustomColumnExpressionEditor_AddMetric')}
          menuProps={{
              items: menuItems,
              calloutProps: {
                preventDismissOnScroll: true,
              },
              className: metricCategoryDropDownClassName,
            }}
          className="btn-command"
        />
        {operators}
      </div>
    );
  }
}
